import { SquareCardContextProvider } from "@ncs/web-legos/contexts"

export const SquareWrapper: React.FC = ({ children }) => {
	return (
		<SquareCardContextProvider
			squareUrl={import.meta.env.VITE_SQUAREUP_URL}
			applicationId={import.meta.env.VITE_SQUAREUP_APPLICATION_ID}
			locationId={import.meta.env.VITE_SQUAREUP_LOCATION_ID}
		>
			{children}
		</SquareCardContextProvider>
	)
}
